module.exports = __webpack_public_path__ + "public/img/jx.7057a1ee.png";